import { File } from '@peerless/data-access/strapi';

export type ImageSize = 'large' | 'medium' | 'small' | 'thumbnail';
const localUrl = process.env.NEXT_PUBLIC_STRAPI_MEDIA_URL || '/content';

export function formatMediaUrl(image: File, size?: ImageSize) {
  const url = size && image.formats?.[size] ? image.formats?.[size].url : image.url;

  switch (image.provider) {
    case 'local':
      return `${localUrl}${url}`;
    case 'aws-s3':
    default:
      return url ?? '';
  }
}
